module.exports = __webpack_public_path__ + "static/img/欢乐颂年中聚会@2x.218e389.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/欢乐颂年中聚会@2x.png
// module id = m1CS
// module chunks = 0